"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogWizardActions = void 0;
const react_1 = __importStar(require("react"));
const core_1 = require("@veeam/core");
const DesignSystem_1 = require("../../../DesignSystem");
const Dialog_1 = require("../../../Dialog");
const helpers_1 = require("../../../helpers");
exports.DialogWizardActions = (0, helpers_1.createUIElement)('DialogWizardActions', (_a, ref) => {
    var { className, loading, prev, next, skip, done, cancel, onClick, onMouseDown, onMouseUp, onMouseEnter, onMouseLeave, onKeyDown, onKeyUp, onKeyPress, style, ['data-selector-id']: initialDataSelectorId } = _a, rest = __rest(_a, ["className", "loading", "prev", "next", "skip", "done", "cancel", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style", 'data-selector-id']);
    const { t } = (0, core_1.useFeatureContext)();
    const dataSelectorId = (0, react_1.useMemo)(() => initialDataSelectorId || 'dialog-wizard-actions', [initialDataSelectorId]);
    const prevAction = (0, react_1.useMemo)(() => !prev.disabled && {
        id: 'prev',
        text: prev.text || t('wizard|actions|previous') || 'Previous',
        view: prev.view || Dialog_1.ACTION_VIEW.alternate,
        onClick: prev.didSelect
    }, [prev.didSelect, prev.disabled, prev.text, prev.view, t]);
    const nextAction = (0, react_1.useMemo)(() => !next.disabled && {
        id: 'next',
        text: next.text || t('wizard|actions|next') || 'Next',
        view: next.view || Dialog_1.ACTION_VIEW.primary,
        onClick: next.didSelect
    }, [next.didSelect, next.disabled, next.text, next.view, t]);
    const skipAction = (0, react_1.useMemo)(() => !skip.disabled && {
        id: 'skip',
        text: skip.text || t('wizard|actions|skip') || 'Skip',
        view: skip.view || Dialog_1.ACTION_VIEW.primary,
        onClick: skip.didSelect
    }, [skip.didSelect, skip.disabled, skip.text, skip.view, t]);
    const doneAction = (0, react_1.useMemo)(() => !done.disabled && {
        id: 'done',
        text: done.text || t('wizard|actions|done') || 'Finish',
        view: done.view || Dialog_1.ACTION_VIEW.primary,
        onClick: done.didSelect
    }, [done.didSelect, done.disabled, done.text, done.view, t]);
    const cancelAction = (0, react_1.useMemo)(() => ({
        id: 'cancel',
        text: cancel.text || t('wizard|actions|cancel') || 'Cancel',
        view: cancel.view || Dialog_1.ACTION_VIEW.secondary,
        onClick: cancel.didSelect
    }), [cancel.didSelect, cancel.text, cancel.view, t]);
    const { isModernUI } = (0, DesignSystem_1.useUI)();
    const primary = (0, react_1.useMemo)(() => isModernUI
        ? [cancelAction, prevAction, nextAction, skipAction, doneAction].filter(Boolean)
        : [prevAction, nextAction, skipAction, doneAction, cancelAction].filter(Boolean), [cancelAction, doneAction, isModernUI, nextAction, prevAction, skipAction]);
    return (react_1.default.createElement(Dialog_1.DialogActions, Object.assign({}, rest, { ref: ref, style: style, "data-selector-id": dataSelectorId, loading: loading, primary: primary, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, className: (0, helpers_1.cn)('vm-DialogWizardActions', className) })));
});
//# sourceMappingURL=DialogWizardActions.js.map